module.exports = __webpack_public_path__ + "static/Lupa-827dd4e21db8389b6713091beda183f1.svg";